export const analytics = (w, d, s, l, i) => {
    w.dataLayer = window.dataLayer || []
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var dl = l !== 'dataLayer' ? '&l=' + l : ''
    var scr = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    /*
          To avoid Multiple installations of google tag manager detected warning
      */
    if (!scriptExists(scr)) {
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement('script')
      // Use async for dynamically injected scripts (defer only works on static scripts)
      j.async = true
      j.src = scr
      // Insert at end of body if available for better performance
      // This ensures GTM doesn't block critical rendering
      var target = d.body
      if (target) {
        target.appendChild(j)
      } else {
        // Fallback: insert in head if body not available yet
        f?.parentNode?.insertBefore(j, f)
      }
    }
  }
  
  const scriptExists = (url) => {
    var scripts = document.getElementsByTagName('script')
    for (var i = scripts.length; i--; ) {
      if (scripts[i].src === url) return true
    }
    return false
  }